<button (click)="matSelect.open()" class="btn-icon" style="max-width: 35px;">
    <img *ngIf="color === 'blue'" src="../../../../assets/images/New design/filter.svg" alt="">
    <img *ngIf="color === 'white'" src="../../../../assets/images/New design/filter_white.svg" alt="">
    <mat-select class="select" (selectionChange)='sortUpdate.emit($event.value)' #matSelect [(ngModel)]="actualSort"  [panelClass]="bExpandOnLeftSide ? 'expand-on-left' : ''" >
        <mat-option *ngFor="let type of sortList" [value]="type.value"> {{ type.viewValue }}</mat-option>
    </mat-select>
</button>
